import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { LegalFooter } from 'common';
import { fetchLegalFooter } from './LegalFooterSlice';
import { LegalFooterContentSelector } from './LegalFooterContentSelector';

export function useLegalFooter(): AbstractContentState<LegalFooter> {
    return useCmsContent(fetchLegalFooter, LegalFooterContentSelector);
}
